import {FormFieldBaseSupplier} from "./form-fieldbase-supplier";

export class FormFieldColorPickerSupplier extends FormFieldBaseSupplier<any> {
  controlType = 'colorpicker';

  constructor(options :any){
    super(options);
  }
}
